import { useEffect } from "react";
import { throttle } from "throttle-debounce";

function useRefreshScrollRestoration() {
  useEffect(() => {
    const pageAccessedByReload = window.performance
      .getEntriesByType("navigation")
      .some((nav) => nav.type === "reload");

    const hasHash = !!window.location.hash;

    if (pageAccessedByReload && !hasHash) {
      const scrollPosition = Number.parseInt(
        sessionStorage.getItem("scrollPosition") || "0",
        10
      );
      if (!isNaN(scrollPosition)) {
        window.scrollTo(0, scrollPosition);
      }
    } else if (hasHash) {
      const hash = window.location.hash;
      const element = document.querySelector(hash);
      if (element) {
        const yOffset = -100;
        const y =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }

    const handleScroll = throttle(500, () => {
      sessionStorage.setItem("scrollPosition", `${window.scrollY}`);
    });

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
}

export default useRefreshScrollRestoration;
